import { useEffect, useState } from "react"
import { useQuery } from "@tanstack/react-query"
import { GraphQLClient } from "graphql-request"
import { useGlobalState } from "providers/globalState"
import datesQuery from "services/craft/queries/dates"
import { TZDate } from "@date-fns/tz"
import { compareDesc, format, parseISO } from "date-fns"

const client = new GraphQLClient(process.env.NEXT_PUBLIC_CRAFT_GQL_URL)

export default function useDates(dateType = "keyDates") {
    const { site } = useGlobalState()
    const [dateGroups, setDateGroups] = useState([])
    const [finalStatus, setFinalStatus] = useState("loading")
    const { status, data, error } = useQuery({
        queryKey: [`dates-${dateType}`],
        queryFn: async () => {
            const variables = {
                siteId: site.meeting.siteId,
                dateType: dateType,
            }

            return await client.request(datesQuery, variables).then(data => {
                return data.data
            })
        },
        refetchOnWindowFocus: false,
        enabled: true,
    })

    useEffect(() => {
        if (status !== "success") {
            setFinalStatus(status)
            return
        }

        const modifiedData = data.map(dateGroup => ({
            ...dateGroup,
            myProperty: "test", // Example of adding a custom property at the group level
            dateItems: dateGroup.dateItems.map(dateItem => ({
                ...dateItem,
                isActive: dateIsActive(dateItem.dateExpires),
            })),
        }))

        setDateGroups(modifiedData)
        setFinalStatus(status)
    }, [data])

    // logic to determine if a date is active
    const dateIsActive = expiredDate => {
        // console.log("------start-------")
        // console.log(expiredDate)
        // console.log(site.meeting.timezone.value)

        if (expiredDate === null) {
            return true
        } else {
            const currentDate = new Date()
            const currentDateTime = format(new TZDate(currentDate, "America/New_York"), "yyyy-MM-dd HH:mm:ssXXX")
            const expiredDateFormatted = format(
                new TZDate(new Date(expiredDate), site.meeting.timezone.value),
                "yyyy-MM-dd HH:mm:ssXXX",
            )

            return compareDesc(parseISO(currentDateTime), parseISO(expiredDateFormatted)) > 0
        }
    }

    return {
        status: finalStatus, // loading, success, error
        error,
        dateGroups,
    }
}
